import { render, staticRenderFns } from "./transaction-statistic.vue?vue&type=template&id=51b17da4"
import script from "./transaction-statistic.vue?vue&type=script&lang=js"
export * from "./transaction-statistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports